export const whyChooseData = [
  {
    id: 1,
    title: "Tailored Solutions",
    content:
      "Custom software is designed to meet specific business needs, ensuring seamless integration with existing operations.",
    img: require("../../../image/supplychain/why-choose-img-one.webp"),
  },
  {
    id: 2,
    title: "Scalability",
    content:
      "A supply chain software development company builds scalable solutions that grow with your business needs.",
    img: require("../../../image/supplychain/why-choose-img-two.webp"),
  },
  {
    id: 3,
    title: "Competitive Advantage",
    content:
      "Custom solutions provide unique functionalities that help businesses outperform competitors.",
    img: require("../../../image/supplychain/why-choose-img-three.webp"),
  },
  {
    id: 4,
    title: " Enhanced Security",
    content:
      "With tailored supply chain management software development, businesses get robust security features to protect sensitive data.",
    img: require("../../../image/supplychain/why-choose-img-four.webp"),
  },
];
